<template>
    <div id="release-of-information">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <admin-release-of-information-toolbar></admin-release-of-information-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <admin-release-of-information-data ref="adminRoi" :data="data">
                    </admin-release-of-information-data>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AdminReleaseOfInformationData from '../../../components/Admin/Forms/ReleaseOfInformation/ReleaseOfInformationData';
import AdminReleaseOfInformationToolbar from '../../../components/Admin/Forms/ReleaseOfInformation/Toolbar';

export default {
    name: 'release-of-information',
    components: {
        AdminReleaseOfInformationData,
        AdminReleaseOfInformationToolbar
    },
    props: {
        username: {
            required: false
        }
    },
    data() {
        return {
            activeRoi: true,
            data: [],
            loader: true,
            refreshTimer: '',
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            }
        }
    },
    methods: {
        getResidenceAssistantData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getROI`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        that.data = json.data;
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    }

                    if (that.activeRoi && that.username) {
                        that.setActiveRoi(that.username);
                    }

                    that.activeRoi = false;
                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        refreshData() {
            this.getResidenceAssistantData();
        },
        setActiveRoi(username) {
            if (username) {
                let user = '';

                // Find user
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].username == username) {
                        user = this.data[i];
                        break
                    }
                }

                if (user) {
                    this.$refs.adminRoi.openDialog(user);
                } else {
                    this.setNotification('#ffb822', 'mdi-file-alert', `The Release of Information data could not be found. Either the username is invalid or the Release of Information data does not exist.`, true);
                }
            }
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        }
    },
    created() {
        this.refreshData();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>